import InvestmentProfilesPage from "./InvestmentProfilesPage"

export default InvestmentProfilesPage
